<template>
  <v-container fluid>
    <div class="btn-bar" style="margin-bottom: 30px">
      <v-card>
        <v-card-title>
          <span class="headline mb-0">Module and Function</span>
        </v-card-title>
        <v-card-actions>
          <v-btn @click="createModule">新增module</v-btn>
          <v-btn @click="editModule" :disabled="selectedModules.length !== 1"
            >編集module</v-btn
          >
          <!-- <v-btn @click="deleteModule" :disabled="selectedModules.length !== 1"
            >削除module</v-btn
          > -->
          <v-btn
            @click="createFunction()"
            :disabled="selectedModules.length !== 1"
            >新增function</v-btn
          >
          <v-btn @click="editFunction" :disabled="selectedItems.length !== 1"
            >編集function</v-btn
          >
          <v-btn @click="deleteFunction" :disabled="selectedItems.length !== 1"
            >削除function</v-btn
          >
          <v-btn @click="exportModuleAndFunctions">导出权限</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div class="content" style="height: calc(100vh - 250px); overflow: scroll">
      <v-form v-model="valid">
        <v-card class="mt-2">
          <v-card-title>詳細情報</v-card-title>
          <v-container fluid>
            <v-layout
              :key="group"
              mb-2
              row
              style="border: 1px solid #ccc"
              v-for="group in groups"
            >
              <v-flex style="margin: auto" text-md-center title xs1>{{
                group
              }}</v-flex>
              <v-flex xs11>
                <v-layout
                  :key="index"
                  row
                  v-for="(module, index) in moduleOfGroup(group)"
                  wrap
                >
                  <v-flex xs2>
                    <v-checkbox
                      :label="module.module_name"
                      :value="module.module_id"
                      v-model="selectedModules"
                      class="subheading font-weight-black"
                    />
                  </v-flex>
                  <v-flex xs10>
                    <v-checkbox
                      :key="index"
                      :label="funcs.function_name"
                      :value="funcs.function_id"
                      class="d-inline-flex mr-3"
                      v-for="(funcs, index) in functionOfModule(
                        module.module_id
                      )"
                      v-model="selectedItems"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </div>
    <f-dialog @refresh="refresh()" ref="fDlg"></f-dialog>
    <m-dialog @refresh="refresh()" ref="mDlg"></m-dialog>
  </v-container>
</template>
<script>
import fDialog from './functionDialog'
import mDialog from './moduleDialog'
/* eslint-disable no-console */
export default {
  components: { mDialog, fDialog },
  data() {
    return {
      valid: true,
      groups: [],
      modules: [],
      functions: [],
      selected: [],
      selectedItems: [],
      selectedModules: [],
      roleFunction: [],
      form: {
        roleCode: null,
        roleCode_local: null,
      },
    }
  },
  methods: {
    exportModuleAndFunctions() {
      let result = []
      for (let i = 0; i < this.groups.length; i++) {
        const modules = this.moduleOfGroup(this.groups[i])
        if (modules.length == 0) {
          modules.push({ module_id: '', module_code: '', module_name: '' })
        }
        for (let j = 0; j < modules.length; j++) {
          const functions = this.functionOfModule(modules[j].module_id)
          if (functions.length == 0) {
            functions.push({ code: '', function_name: '' })
          }
          for (let k = 0; k < functions.length; k++) {
            const element = {}

            if (j === 0 && k === 0) {
              element['group'] = this.groups[i]
            } else {
              element['group'] = ''
            }

            if (k === 0) {
              element['module_code'] = modules[j].module_code
              element['module_name'] = modules[j].module_name
            } else {
              element['module_code'] = ''
              element['module_name'] = ''
            }

            element['code'] = functions[k].code
            element['function_name'] = functions[k].function_name
            result.push(element)
          }
        }
      }
      this.$exportTable(
        result,
        ['group', 'module_code', 'module_name', 'code', 'function_name'],
        [
          'group name',
          'module code',
          'module name',
          'function code',
          'function name',
        ],
        '权限管理出力'
      )
    },
    refresh() {
      this.load()
    },
    createModule() {
      this.$refs.mDlg.popupNew({})
    },
    editModule() {
      this.$refs.mDlg.popupEdit(
        this.modules.find((i) => i.module_id === this.selectedModules[0])
      )
    },
    createFunction() {
      this.$refs.fDlg.popupNew(
        this.modules.find((m) => m.module_id === this.selectedModules[0]),
        { module_id: this.selectedModules[0] }
      )
    },
    editFunction() {
      const func = this.functions.find(
        (f) => f.function_id === this.selectedItems[0]
      )
      this.$refs.fDlg.popupEdit(
        this.modules.find((m) => m.module_id === func.module_id),
        func
      )
    },
    deleteFunction() {
      this.$confirm({
        content: `确定削除function: ${
          this.functions.find((f) => f.function_id === this.selectedItems[0])
            .function_name
        }`,
      }).then(() => {
        this.deleteFunctionRequest(this.selectedItems[0])
          .then((res) => {
            if (res.data.ret_code === '00000') {
              this.$message('', this.$t('app.messages.removeSuccess'))
              this.refresh()
            } else {
              this.$message('', `${res.data.ret_code}: ${res.data.ret_msg}`)
            }
          })
          .catch((res) => {
            this.$message(
              '',
              `${res.response.data.ret_code}: ${res.response.data.ret_msg}`
            )
          })
      })
    },
    deleteFunctionRequest(functionId) {
      return this.$http.patch('/basic-data/sys-functions', {
        function_id: functionId,
        deleted_flag: 1,
      })
    },
    deleteModule() {
      this.$confirm({
        content: `确定削除module: ${
          this.modules.find((m) => m.module_id === this.selectedModules[0])
            .module_name
        }`,
      }).then(() => {
        Promise.all(
          this.functions
            .filter((f) => f.module_id === this.selectedModules[0])
            .map((f) => this.deleteFunctionRequest(f.function_id))
        )
          .then((res) => {
            if (res.filter((i) => i.data.ret_code !== '00000').length > 0) {
              const result = res.filter((i) => i.data.ret_code !== '00000')[0]
              this.$message(
                '',
                `${result.data.ret_code}: ${result.data.ret_msg}`
              )
              this.refresh()
            } else {
              this.$http
                .patch('/basic-data/sys-modules', {
                  module_id: this.selectedModules[0],
                  deleted_flag: 1,
                })
                .then((res) => {
                  if (res.data.ret_code === '00000') {
                    this.$message('', this.$t('app.messages.removeSuccess'))
                  } else {
                    this.$message(
                      '',
                      `${res.data.ret_code}: ${res.data.ret_msg}`
                    )
                  }
                  this.refresh()
                })
                .catch((res) => {
                  this.$message(
                    '',
                    `${res.response.data.ret_code}: ${
                      res.response.data.ret_msg
                    }`
                  )
                })
            }
          })
          .catch((res) =>
            this.$message(
              '',
              `${res.response.data.ret_code}: ${res.response.data.ret_msg}`
            )
          )
      })
    },
    moduleOfGroup(group) {
      return this.modules.filter(
        (m) => m.description && !m.description.localeCompare(group)
      )
    },
    functionOfModule(module) {
      return this.functions.filter(
        (m) => m.module_id && !m.module_id.localeCompare(module)
      )
    },

    loadModules() {
      return this.$http
        .get('/basic-data/sys-modules?page_index=1&page_size=1')
        .then((res) => {
          let total = res.data.page_result.total
          let urls = []
          for (let i = 0; i < total / 50; i++) {
            urls.push(
              `/basic-data/sys-modules?page_index=${i + 1}&page_size=50`
            )
          }
          Promise.all(urls.map(this.$http.get)).then((res) => {
            this.modules = res
              .filter((r) => r.data.ret_code === '00000')
              .reduce((t, r) => [...t, ...r.data.page_result.result], [])
              .filter(
                (p) =>
                  p.application_code &&
                  !p.application_code.localeCompare('SHARP')
              )
              .sort((a, b) => {
                return a.module_id.localeCompare(b.module_id)
              })
            this.groups = [...new Set(this.modules.map((m) => m.description))]
          })
        })
    },
    loadFunctions() {
      return this.$http
        .get('/basic-data/sys-functions?page_index=1&page_size=1') //只是用来获取总数
        .then((res) => {
          let total = res.data.page_result.total
          let urls = []
          for (let i = 0; i < total / 50; i++) {
            urls.push(
              `/basic-data/sys-functions?page_index=${i + 1}&page_size=50`
            )
          }
          Promise.all(urls.map(this.$http.get)).then((res) => {
            this.functions = res
              .filter((r) => r.data.ret_code === '00000')
              .reduce((t, r) => [...t, ...r.data.page_result.result], [])
          })
        })
    },

    clear() {
      this.selected = []
      this.selectedModules = []
      this.selectedItems = []
      this.groups = []
      this.modules = []
      this.functions = []
      this.roleFunction = []
    },
    load() {
      this.clear()
      Promise.all([this.loadModules(), this.loadFunctions()]).then(() => {})
    },
    selectedFunctionsOfModuleId(module_id) {
      return this.functions
        .filter(
          (f) =>
            f.module_id === module_id &&
            this.selectedItems.includes(f.function_id)
        )
        .map((f) => f.function_id)
    },
  },
  mounted() {
    this.load()
  },
}
</script>
